import { render } from "./Start.vue?vue&type=template&id=63188c53&ts=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import exportComponent from "/home/deploy/2290059a64cb5b6694a8/Front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__